
import qs from './queryString';
import httpProxy from '@/net/httpProxy';

var switchMap = {};

const download = {
    // app内判断下载或打开其它app时，用的app名称
    packageNameMap : {
        'iostea': 'tfastcalculation://',
        'iosstu': 'kbstudentapp://',
        'iosnew': 'sfastcalculation://',
    
        'andtea': 'com.knowbox.rc.teacher',
        'andstu': 'com.knowbox.rc.student',
        'andnew': 'com.knowbox.rc.student.pk',
    },
    // android app内下载提示
    androidTipsMap : {
        'andtea': '正在下载老师端',
        'andstu': '正在下载学生端',
        'andnew': '正在下载小盒家长',
    },
    browser: {
        versions: function () {
            var u = navigator.userAgent;
            return {//移动终端浏览器版本信息
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
                iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
            };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    },
    
    isRunInApp() {
        // var hasToken = window.location.search.match(/token=/i);
        //window.navigator.userAgent:返回由客户机发送服务器的 user-agent 头部的值。
        return window.navigator.userAgent.toLowerCase().indexOf('knowbox') > -1;
    },
    
    // 获取app下载包地址
    async getAppList(os) {
        var url = 'https://stuapi.knowbox.cn/official-web/official-web/get-package-list';
        var channelFrom = qs && qs.getValue('channelFrom') ? '?channel=' + qs.getValue('channelFrom') : '';
        var platform = os ? os : (download.browser.versions.ios || download.browser.versions.iPhone || download.browser.versions.iPad) ? 'ios' : 'android';
    
        url += channelFrom; 
        url += (url.indexOf('?') > -1 ? '&' : '?') + 'os=' + platform;
    
        // $.ajax({
        //     url: url + '&ts=' + Date.now() 
        // }).then(function(data) {
        //     if (data.code === 99999) {
        //         switchMap = data.data;
        //     } else {
        //         console.log('获取app下载地址失败。');
        //     }
        // });
        const query = '&ts=' + Date.now()
        const { data: {code, data}  } = await httpProxy(url + query);

        if(code === 99999){
            switchMap = data;

        }else{
            // console.log('获取app下载地址失败。');
        }
    },
    jumpFn(whitch) {
        console.log('whitch',whitch);
        if (!Object.keys(switchMap).length || !switchMap[whitch]) {
            return;
        }
    
        // if (window.qs && qs[switchMap[whitch].actionCode]) {
        //     if (window.h5Record) {
        //         h5Record.sendAnonymous(qs[switchMap[whitch].actionCode]);
        //     }
        // }
    
        setTimeout(function () {
            if (download.isRunInApp()) {
                // openKnowboxClient(packageName, downloadUrl, downloadTips)
                var packageName = download.packageNameMap[whitch];
                var hybirdUrl = 'hybird://method/openKnowboxClient?packageName=' + encodeURIComponent(packageName) + '&downloadUrl=' + encodeURIComponent(switchMap[whitch].url);
                // android 需要下载进度提示
                if (whitch.match('and')) {
                    hybirdUrl += '&downloadTips=' + encodeURIComponent(download.androidTipsMap[whitch]);
                }
                window.location.href = hybirdUrl;
            } else {
                window.location.href = switchMap[whitch].url;
            }
        }, 300);
    }           
};
download.getAppList();
export default download;